import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { HeaderInfo } from 'CorePackage/HeaderInfoModule/components/HeaderInfo';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { DATE_FORMAT_LONG_MINUTE } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { TablePage } from 'CorePackage/TableModule/components/TablePage';

import { getErknmAnalyticsData, getErknmAnalyticsDateTime } from '../selectors/erknmAnalyticsSelectors';
import { erknmAnalyticsInitPage } from '../actions/erknmAnalyticsActions';
import { ErknmAnalyticsPanel } from './ErknmAnalyticsPanel';
import { ErknmAnalyticsTable } from './ErknmAnalyticsTable';
import { Row } from '../../../UIPackage/FormModule/components/Row';
import styles from './ErknmAnalyticsTable.module.scss';
import { IErknmAnalyticsIndex } from '../../../APIPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsIndex';

interface IErknmAnalyticsProps {
  localDateTime: string;
  data: IErknmAnalyticsIndex[];
}

const ErknmAnalyticsWithoutStore = ({ localDateTime, data }: IErknmAnalyticsProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [isShowAnalyticsTable, setIsShowAnalyticsTable] = useState<boolean>(false);

  useEffect(() => {
    dispatch(erknmAnalyticsInitPage());
  }, [dispatch]);

  useEffect(() => {
    if (data.length > 0) {
      setIsShowAnalyticsTable(true);
    }
  }, [data]);

  return (
    <>
      <HeaderInfo
        formedDate={formatDate({
          date: localDateTime,
          dateFormat: DATE_FORMAT_LONG_MINUTE,
        })}
      />
      <TablePage>
        <div className="shared-panel-container">
          <ErknmAnalyticsPanel />
        </div>
        {isShowAnalyticsTable && <ErknmAnalyticsTable />}
      </TablePage>

      {!isShowAnalyticsTable && (
        <Row notSpace notWrap>
          <div className={styles.InfoBody}>
            <div className={styles.TooltipIcon}></div>
            <div>Для просмотра аналитических данных заполните параметры поиска и нажмите кнопку “Применить”</div>
          </div>
        </Row>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState) => ({
  localDateTime: getErknmAnalyticsDateTime(state),
  data: getErknmAnalyticsData(state),
});

export const ErknmAnalytics = connect(mapStateToProps)(ErknmAnalyticsWithoutStore);
